import { jsx } from 'react/jsx-runtime';
import { Grid } from '@mui/material';
import moment from 'moment';
import { DatePicker } from '../../DatePicker.js';
import 'date-fns/locale/pt-BR';
import '@mui/x-date-pickers/AdapterDateFns';
import '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/DatePicker';

const Date = ({ label, value, name, handleChange }) => {
    return (jsx(Grid, Object.assign({ item: true, lg: 6, md: 12, sm: 12, xs: 12 }, { children: jsx(DatePicker, { label: label, value: moment(value).toString(), handleChange: handleChange, name: `${name}` }) })));
};

export { Date };
